import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { PaginationLimit } from "../../Config";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { PrevBtn, NextBtn, PaginationWrapper } from "../Styles/PageStyles";
import { IoMdMore } from "react-icons/io";
import {
  FaBolt,
  FaHome,
  FaTools,
  FaUserFriends,
  FaUserShield,
  FaWrench,
} from "react-icons/fa";
import {
  MdCarpenter,
  MdLocalLaundryService,
} from "react-icons/md";
import { FaBowlFood } from "react-icons/fa6";
import { GiPoliceOfficerHead, GiTakeMyMoney } from "react-icons/gi";
import { PiOfficeChairBold } from "react-icons/pi";
import { FcSalesPerformance } from "react-icons/fc";
import { SiHelpdesk } from "react-icons/si";
import moment from "moment";

const Table = ({
  ApiData,
  setSelectedData,
}) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [currentPage, setCurrentPage] = useState(0);
  const [openActionMenu, setOpenActionMenu] = useState(null);
  const [data, setData] = useState([
    {
      deviceName: "",
      extractionTime: "",
      processingTime: "",
      drops: "",
      action: "",
    },
  ]);

  const toggleRow = (index) => {
    setSelectedRow(selectedRow === index ? null : index);
  };
  const [selectedRow, setSelectedRow] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const getRole = (indx) => {
    switch (parseInt(indx)) {
      case 1:
        return (
          <p className="bg-teal-100 text-gray-500 border-teal-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaUserShield className="inline mr-2 text-gray-500" />
            Admin
          </p>
        );
      case 2:
        return (
          <p className="bg-lime-100 text-gray-500 border-lime-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaHome className="inline mr-2 text-gray-500" />
            Warden
          </p>
        );
      case 3:
        return (
          <p className="bg-amber-100  text-grayr-500 border-amber-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaBolt className="inline mr-2 text-gray-500" />
            Electrician
          </p>
        );
      case 4:
        return (
          <p className="bg-indigo-100 text-gray-500 border-indigo-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaWrench className="inline mr-2 text-gray-500" />
            Plumber
          </p>
        );
      case 5:
        return (
          <p className="bg-pink-100 text-gray-500 border-pink-300  border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <MdLocalLaundryService className="inline mr-2 text-gray-500" />
            Laundry
          </p>
        );
      case 6:
        return (
          <p className="bg-cyan-100 text-gray-500 border-cyan-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <MdCarpenter className="inline mr-2 text-gray-500" />
            Carpenter
          </p>
        );
      case 7:
        return (
          <p className="bg-purple-100 text-gray-500 border-purple-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaUserFriends className="inline mr-2 text-gray-500" />
            Partner
          </p>
        );
      case 8:
        return (
          <p className="bg-orange-100 text-gray-500 border-orange-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaBowlFood className="inline mr-2 text-gray-500" />
            Cook
          </p>
        );
      case 9:
        return (
          <p className="bg-yellow-100 text-gray-500 border-yellow-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <MdLocalLaundryService className="inline mr-2 text-gray-500" />
            Housekeeping
          </p>
        );
      case 10:
        return (
          <p className="bg-amber-100 text-gray-500 border-amber-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FcSalesPerformance className="inline mr-2 text-gray-500" />
            Sales Person
          </p>
        );
      case 11:
        return (
          <p className="bg-sky-100 text-gray-500 border-sky-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <GiPoliceOfficerHead className="inline mr-2 text-gray-500" />
            Security Guard
          </p>
        );
      case 12:
        return (
          <p className="bg-violet-100 text-gray-500 border-violet-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <GiTakeMyMoney className="inline mr-2 text-gray-500" />
            Finance
          </p>
        );
      case 13:
        return (
          <p className="bg-fuchsia-100 text-gray-500 border-fuchsia-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <PiOfficeChairBold className="inline mr-2 text-gray-500" />
            Back Office
          </p>
        );
        case 14:(
          <p className="bg-rose-200 text-gray-500 border-rose-300 border text-xs py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <SiHelpdesk className="inline mr-2 text-gray-500" />
            Help Desk
          </p>
        )
      default:
        return (
          <p className="bg-rose-100 text-gray-500 text-xs border-rose-300 border py-1 max-w-fit h-7 px-4 flex items-center justify-center rounded">
            <FaTools className="inline mr-2 text-gray-500" />
            Not assigned
          </p>
        );
    }
  };

  const getTenantGender = (gender) => {
    if (gender === 1) {
      return "Male";
    } else {
      return "Female";
    }
  };

  const getState = (item) => {
    let state = null;
    if (item === "NOT_INUSE")
      state = { value: "Online", color: "bg-emerald-500" };
    else if (item === "INUSE") state = { value: "Busy", color: "bg-amber-500" };
    else if (item === "UNAVAILABLE")
      state = { value: "Offline", color: "bg-slate-400" };
    else if (item === "RINGING")
      state = { value: "Ringing", color: "bg-blue-500" };
    else {
      state = { value: "Inactive", color: "bg-rose-600" };
    }

    return (
      <div
        className={`flex gap-2 text-sm font-medium text-zinc-500 items-center`}
      >
        <span className={`h-3 w-3 rounded-full ${state.color}`}></span>
        <span>{state.value}</span>
      </div>
    );
  };

  const getName = (item) => {
    return (
      <div className="flex gap-2 items-center">
        <img
          src="/images/avatar.png"
          alt="Client"
          className="w-9 h-9 rounded-full overflow-hidden"
        />
        <div className="flex flex-col gap-1">
          <span className="text-zinc-900 font-semibold">
            {item.name}{" "}
            <span className="text-xs bg-zinc-100 text-zinc-500 px-1 rounded-sm">
              {getTenantGender(item.gender)}
            </span>
          </span>
          <span className="text-yellow-500 text-xs">#{item.mobile}</span>
        </div>
      </div>
    );
  };

  const getLastLogin = (item)=>{
    if(!item.lastLogin){
      return(
        <span></span>
      );
    }
    return(
      <div className="flex flex-col">
        <span className="text-sm font-medium text-zinc-900">{moment(item.lastLogin).format("ll")}</span>
        <span className="text-xs font-medium text-gray-400">{moment(item.lastLogin).format("hh:mm A")}</span>
      </div>
    );
  };


  useEffect(() => {
    if (ApiData) {
      const tempData = ApiData.map((item) => ({
        name: getName(item),
        clientName: item?.clientName || "NA",
        Role: getRole(item.role),
        Number: <div className="text-yellow-500">#{item.mobile}</div>,
        Salary:
          item.salary === 0 ? <div>--/--</div> : <div> ₹ {item.salary}</div>,
        status:
          item.status === 1 ? (
            <div className="bg-green-100 text-green-700 text-xs border-green-300 border w-24 h-7 flex items-center justify-center rounded-full">
              Active
            </div>
          ) : (
            <div className="bg-gray-100 text-gray-700 text-xs border-gray-300 border w-24 h-7 flex items-center justify-center rounded-full">
              Inactive
            </div>
          ),
        lastLogin: getLastLogin(item),  
      }));
      setData(tempData);
    }
  }, [ApiData, openActionMenu]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("#menuOptions") &&
        !event.target.closest(".action-btn")
      ) {
        setOpenActionMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const columns = useMemo(() => {
    if (isMobileView) {
      // Display only "User" column for mobile screens
      return [
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Role",
          accessor: "Role",
        },
      ];
    }

    // Columns for larger screens
    return [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Role",
        accessor: "Role",
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Last Login",
        accessor: "lastLogin",
      },
    ];
  }, [isMobileView]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    pageOptions,
    page,
    state: { pageIndex, pageSize },
    previousPage,
    nextPage,
    setPageSize,
    canPreviousPage,
    canNextPage,
  } = useTable(
    {
      data,
      columns,
      initialState: { pageIndex: currentPage, pageSize: PaginationLimit },
    },
    useSortBy,
    usePagination
  );
  useEffect(() => {
    setCurrentPage(pageIndex); // Update current page on state change
  }, [pageIndex]);
  return (
    <>
      <CustomTable {...getTableProps()}>
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  <span>
                    {column.isSorted ? (
                      <img
                        src={Images.Arrow}
                        alt="down arrow"
                        className={`${
                          column.isSortedDesc ? "-rotate-90" : "rotate-90"
                        } w-1.5 inline-block ml-1.5`}
                      />
                    ) : (
                      ""
                    )}
                  </span>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody
          {...getTableBodyProps()}
          hasdata={(ApiData?.length > 0).toString()}
        >
          {page.map((row, rowIndex) => {
            prepareRow(row);
            return (
              <React.Fragment key={rowIndex}>
                <Tr
                  {...row.getRowProps()}
                  hasdata={(ApiData?.length > 0).toString()}
                >
                  {row.cells.map((cell, cellIndex) => {
                    return (
                      <Td
                        {...cell.getCellProps()}
                        onClick={() => {
                          if (
                            cellIndex === 0 ||
                            (cellIndex === 1 && window.innerWidth < 768)
                          ) {
                            toggleRow(rowIndex);
                          }
                        }}
                      >
                        {cell.render("Cell")}
                      </Td>
                    );
                  })}
                </Tr>
                {selectedRow === rowIndex && window.innerWidth < 768 && (
                  <Tr>
                    <Td colSpan={columns.length}>
                      <ul className="flex flex-col gap-2">
                        <li>
                          <strong>City:</strong> {data[rowIndex].city}
                        </li>
                        <li>
                          <strong>Created At:</strong> {data[rowIndex].date}
                        </li>
                        <li className="flex gap-2">
                          <strong>Status:</strong> {data[rowIndex].status}
                        </li>
                        <li>
                          <strong>Action:</strong> {data[rowIndex].action}
                        </li>
                      </ul>
                    </Td>
                  </Tr>
                )}
              </React.Fragment>
            );
          })}
        </Tbody>
      </CustomTable>
      {ApiData?.length > 0 && (
        <PaginationWrapper>
          <div className="px-2">
            Page{" "}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
          <div className="flex gap-1">
            <PrevBtn onClick={() => previousPage()} disabled={!canPreviousPage}>
              <img src={Images.Arrow} alt="arrow" className="w-2 opacity-75 " />
            </PrevBtn>
            <NextBtn onClick={() => nextPage()} disabled={!canNextPage}>
              <img
                src={Images.Arrow}
                alt="arrow"
                className="w-2 rotate-180 opacity-75 "
              />
            </NextBtn>
          </div>
        </PaginationWrapper>
      )}
    </>
  );
};
const MenuItem = tw.div`flex items-center gap-2 px-4 py-2 text-base font-medium cursor-pointer hover:bg-gray-100`;
const MenuOptions = tw.div`absolute bottom-10 right-0 py-4 w-max bg-white z-50 rounded-lg shadow-lg border border-gray-200 flex flex-col`;
const Td = tw.td`p-3 text-sm md:p-3 text-left`;
const Th = tw.th`text-left text-sm md:p-3 p-0.5 font-medium text-gray-500`;
const Btn = tw.button`action-btn grid place-items-center border border-gray-300 w-8 h-8 rounded-full transform transition duration-200 hover:scale-110 hover:shadow-md`;
const ActionBtnWrapper = tw.div`flex items-center gap-3 relative`;
// const ActionBtnWrapper = tw.div`grid xl:grid-cols-2 md:grid-cols-1 grid-cols-4 w-40 mb-1 gap-y-1 gap-x-1.5 md:w-16 mt-3 md:mt-0`;
const CustomTable = tw.table` w-full text-zinc-600`;
const Thead = tw.thead`border-b uppercase text-zinc-500 bg-slate-100`;
const Tbody = tw.tbody`${(props) =>
  props.hasdata === "true" ? "border-b" : ""}`;
const Tr = tw.tr`${(props) =>
  props.hasdata === "true"
    ? "border-b"
    : ""} rounded-md overflow-hidden hover:bg-slate-50`;
export default Table;